import {Component} from "@angular/core";
import {NavController, NavParams} from "ionic-angular";
import {LoginProvider} from "../../providers/login/login";
import {GlobalProvider} from "../../providers/global/global";
import {HomePage} from "../home/home";
import {PwaIosProvider} from '../../providers/pwa-ios/pwa-ios';

@Component({
  selector: "page-login-ios",
  templateUrl: "login-ios.html"
})
export class LoginIosPage {
  email: string;
  clave: string;
  idUsuario: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loginProvider: LoginProvider,
    private global: GlobalProvider,
    private pwaIos: PwaIosProvider
  ) {
  }

  login() {
    this.loginProvider.login(this.email, this.clave).subscribe(data => {
      console.log("login", data);
      if (Object.keys(data).length === 0) {
        this.global.crearToast("Usuario o clave errónea", 1500);
      } else {
        if (data["activo"]) {
          console.log("user activo");
          this.global.setlogged(true);
          this.global.setDataUser(data);

          var ukt = this.global.calcula_ukt(this.email, this.clave);
          console.log("ukt", ukt);
          this.global.setukt(ukt);

          console.log("Nos vamos al HOME");
          this.idUsuario = data["id"];

          this.pwaIos.saveInstall(this.idUsuario);

          this.navCtrl.setRoot(HomePage);
        } //Activo
        else {
          this.global.crearToast("Usuario no activo", 1500, "bottom");
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-ios/login-ios.ts